export default {"src":"/_next/static/media/facebook-logo.4e053652.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};